import type { HeadingProps } from './Heading.types';

export const headingDefaults: HeadingProps = {
  tag: 'h1',
  size: 'none',
  context: 'none',
};
